







































































































import { createComponent } from "@vue/composition-api";
import { BasePrimaryButton } from "@web-components";
import ActionPlanActivityCard from "@dcc/components/ActionPlanActivityCard.vue";
import ActionPlanResultsDays from "@dcc/components/ActionPlanResultsDays.vue";
import ActionPlanResultsPercentage from "@dcc/components/ActionPlanResultsPercentage.vue";
import ActionPlanResultsConsumption from "@dcc/components/ActionPlanResultsConsumption.vue";
import ActionPlanResultsDrinks from "@dcc/components/ActionPlanResultsDrinks.vue";
import WeeklyConsumptionPanel from "@dcc/components/WeeklyConsumptionPanel.vue";
import { useDictionary } from "./compositions/useDictionary";
import { SHOW_TIPS_LINK } from "@dcc/constants/links";
//eslint-disable-next-line
import { ActionPlanResultsProps } from "@dcc/views/types/actionPlanResults";
import { useActionPlanResults } from "@dcc/views/compositions/useActionPlanResults";

export default createComponent({
  props: {
    percentage: {
      type: Number,
      required: false
    },
    dropped_days: {
      type: Number,
      required: false
    },
    calories_week: {
      type: Number,
      required: false
    },
    units_week: {
      type: Number,
      required: false
    },
    gender: {
      type: Number,
      required: false
    },
    num_drinking_days: {
      type: Number,
      required: false
    },
    tips: {
      type: Array as () => string[]
    }
  },
  components: {
    BasePrimaryButton,
    ActionPlanActivityCard,
    ActionPlanResultsDays,
    ActionPlanResultsPercentage,
    ActionPlanResultsConsumption,
    ActionPlanResultsDrinks,
    WeeklyConsumptionPanel
  },
  setup(props: ActionPlanResultsProps, context) {
    const dictionary = useDictionary();

    return {
      ...useActionPlanResults(context, props),
      ...dictionary,
      SHOW_TIPS_LINK
    };
  }
});
